module.exports = __webpack_public_path__ + "static/media/31JFA2.4502f668.jpg";